// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_sa-0";
export var checkoutRateBadgeLink = "_sa-1";